import { API_BASE_URL } from "../../config";
import { localeStore } from "../Locale/localeStore";

export const getAuthHeaders = () => ({
	"Authorization": sessionStorage.getItem("loginToken") || "",
	"Content-Type": "application/json"
});

const login = async (password: string) =>
{
	const response = await fetch(`${API_BASE_URL}/auth/login`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify({ "password": password })
	});

	if (!response.ok)
	{
		const errorData = await response.json();
		throw new Error(errorData.error);
	}

	const result = await response.json();

	sessionStorage.setItem('loginToken', result.token);
	localeStore.set(result.locale ?? undefined);

	return result.token;
};

export const authService = {
	getHeaders: getAuthHeaders,
	login,
};